//UI
import { FaCircle, FaFileExcel } from 'react-icons/fa';
import BtnDashboard from '../buttons/BtnDashboard';
//RESOURCERS
import { useLocation, useNavigate } from 'react-router-dom';
import { useToolbarStore } from '../../store/VitalStore';

const ReportList = () => {

    const navigate = useNavigate();
    const location = useLocation();
        const { isToolbarOpen, closeToolbar } = useToolbarStore((state) => state);
    

    return (
        <ul className=''>
            <li
                onClick={(e) => { navigate('/panel/student_with_space'); closeToolbar(); }}
                className={`w-full ${location.pathname.startsWith('/panel/student_with_space') ? 'active' : ''}`}>
                <BtnDashboard>
                    <FaCircle className='ml-5' size={7} />
                    <p>Gestionados</p>
                </BtnDashboard>
            </li>
            <li
                onClick={(e) => { navigate('/panel/student_without_space'); closeToolbar(); }}
                className={`w-full ${location.pathname.startsWith('/panel/student_without_space') ? 'active' : ''}`}>
                <BtnDashboard>
                    <FaCircle className='ml-5' size={7} />
                    <p>Pendientes de gestion</p>
                </BtnDashboard>
            </li>
        </ul>
    );
};

export default ReportList;